export const forms = {
  labels: {
    firstName: "Prénom",
    lastName: "Nom de famille",
    email: "Adresse de courriel",
    phone: "Téléphone",
    privacyAgreement:
    "J’accepte que Maagtechnic SA traite mes données personnelles afin de répondre à ma demande.  Vous trouverez de plus amples informations et des indications de rétractation dans notre <a class=link link-primary' href='/datenschutz' target='__blank'><span> Déclaration de confidentialité </span></a>*",
    submit: "Envoyer",
  },
  hints: {
    requiredFieldsMissing: "Merci de remplir les champs obligatoires manquants",
  },
  contactForm: {
    header: "Formulaire de contact",
    labels: {
      subject: "Concerne",
      message: "Votre message à notre intention",
      reportABug: "Je souhaite signaler un problème",
    },
    hints: {
      maxNCharacters: "Message {n} caractères au maximum",
    },
  },
  bugReport: {
    descriptions: {
      general:
        "Nous vous remercions de prendre le temps de nous signaler un problème.<br> Veuillez décrire plus exactement ce qui s'est passé.",
      optionalFields:
        "Si vous ne pouvez pas répondre à une question, laissez le champ vide.",
      userIntention:
        "Ex. vous vouliez télécharger un fichier 3D ou vous connecter.",
      userExpectation:
        "Ex. votre fichier est analysé ou vos données client sont affichées.",
      systemResponse:
        "Ex. l’analyse a été interrompue ou rien ne se passe.",
    },
    labels: {
      description: "Avez-vous d’autres informations à nous fournir?",
      userIntention: "Que vouliez vous faire sur notre portail?",
      userExpectation: "Quelles réactions attendiez-vous du portail?",
      systemResponse: "Au lieu de cela, quelle a été la réaction du portail?",
      browserUsed: "Quel navigateur utilisez-vous?",
      osUsed: "Quel système d’exploitation utilisez-vous?",
      errorMessageOccurred: "Avez-vous reçu un message d’erreur?",
      errorMessage: "Message d'erreur",
      problemPersistInAnotherBrowser:
        "Le même problème existe-t-il avec un autre navigateur?",
      iDontKnow: "Je ne sais pas",
      otherBrowser: "Autre",
      otherOs: "Autre",
      yes: "Oui",
      no: "Non",
      internetConnection:
      "Pouvez-vous accéder à d’autres sites Internet tels que <a href='https://google.com' target='__blank'>www.google.com</a> ?"
    },
    placeholders: {
      userIntention: "Intention de l’utilisateur",
      userExpectation: "Vos attentes",
      systemResponse: "Réactions constatées",
    },
    hints: {
      maxNCharacters: "Message {n} caractères au maximum",
    },
  },
};
